import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoadingController, NavController, Platform, ToastController } from '@ionic/angular';
import { LoaderProvider } from '../../../providers/loader/loader';
import { RegistrationModel, UserProvider } from '../../../providers/user/user';
import { SessionProvider } from '../../../providers/session/session';
import { ConfigProvider } from '../../../providers/config/config';
import { Router } from '@angular/router';
import { Location, LocationStrategy } from '@angular/common';
import { NavigationService } from 'src/providers/navigation/navigation.service';

@Component({
  selector: 'page-registration',
  templateUrl: 'registration.html',
  styleUrls:['./registration.scss']
})
export class RegistrationPage {
  model: RegistrationModel = {
    password: '',
    password2: '',
    email: ''
  };

  resolve: any = null;
  isLoged: boolean = false;
  isIOS: boolean = false;

  rememberMe: boolean = true;
  constructor(
    public navCtrl: NavController,
    private userService: UserProvider,
    public router:Router,
    private loadingCtrl: LoadingController,
    private translate: TranslateService,
    private toastCtrl: ToastController,
    private sessionService: SessionProvider,
    private platform: Platform,
    private location:Location,
    private navService:NavigationService,
    private locationStrategy: LocationStrategy
  ) {
    this.platform.ready().then(async () => {
      this.isIOS = this.platform.is('ios');
      const nav = this.router.getCurrentNavigation();
      const state = nav?.extras?.state || {};

      if (state?.['resolve'])
        this.resolve = state?.['resolve'];

    });
  }

  ionViewDidEnter() {
    console.log('ionViewDidEnter RegistrationPage');
  }

  ionViewWillLeave() {
    if (this.resolve && this.isLoged) { this.resolve(true) }
  }

  async reg() {
    let loader = await this.loadingCtrl.create({
      message: this.translate.instant('GLOBAL_LOADING')
    });
    loader.present();
    this.model.password2 = this.model.password;
    this.userService.registration(this.model).then(result => {
      loader.dismiss().then(() => {
        console.log('result', result)
        if (result.success) {
          this.sessionService.sendLoggedIn();
          this.isLoged = true;
          this.sessionService.isLoged = true;
          if (this.resolve) { this.resolve(true) }
          if (this.rememberMe) {
            this.sessionService.saveLogin({ email: this.model['email'], password: this.model.password });
          }
          this.locationStrategy.historyGo(-2);
          const forwardUrl = '/tab2/me/mysport/user-profile';
          console.log('this.router.url', this.locationStrategy.path())
          if(!this.locationStrategy.path().includes(forwardUrl)){
            this.navCtrl.navigateForward('/tab2/me/mysport/user-profile')
          }
        } else {
          console.log(this.decodeEntities(result?.message));
          this.toastCtrl
            .create({
              message: this.decodeEntities(this.translate.instant(result?.message)) ||this.translate.instant("ERROR_IN_REGISTRATION"),
              buttons:[{text:'OK', role:'cancel'}]
            }).then(toast=>toast.present());
        }
      });
    });
  }

  /// TODO Its just a quick fix
  decodeEntities = (() => {
    let element = document.createElement('div');
    let entity = /&(?:#x[a-f0-9]+|#[0-9]+|[a-z0-9]+);?/gi;
    return str => {
      str = str.replace(entity, function (m) {
        element.innerHTML = m;
        return element.textContent;
      });
      element.textContent = '';
      return str;
    };
  })();

  onLogin() {
    this.sessionService.isLoged = true;
    console.log(this.sessionService);
    // this.checkForOrganizerLogin();
    // (this.app.getRootNav() as NavController).pop();
    this.location.back();
  }

  checkForOrganizerLogin() {
    if (this.sessionService.profile.status.toLocaleUpperCase().includes("VERANSTALTER")) {
      this.toastCtrl.create({
        message: this.translate.instant('ORGANIZER_LOGIN_MESSAGE'),
        duration: 5000
      }).then(toast=>toast.present());
      this.userService.logout();
    }
  }
}
